module.exports = __webpack_public_path__ + "images/emoji/three.689b5d0e0b69371225bd.png";